import React, { useEffect, useState } from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { glossaire_time_zone } from '../../../ressources/glossaires/glossaire_time_zones';
import styles from './FormulaireSelectionTimeZone.module.scss';

const FormulaireSelectionTimeZone = ({
  preconfigurerTimeZone,
  gererTimeZone,
}) => {
  const [timeZone, setTimeZone] = useState(null);
  const [preconfiguredZone, setPreconfiguredZone] = useState(null);

  useEffect(() => {
    if (preconfigurerTimeZone !== undefined) {
      setTimeZone(preconfigurerTimeZone);
    }
  }, [preconfigurerTimeZone]);

  useEffect(() => {
    if (timeZone !== preconfiguredZone) {
      gererTimeZone(timeZone);
      setPreconfiguredZone(timeZone);
    }
  }, [timeZone, preconfiguredZone, gererTimeZone]);

  const handleTimeZoneChange = (event) => {
    setTimeZone(event.target.value);
  };

  return (
    <>
      <span className={[styles.stil2].join(' ')}>{checkMot('time_zone')}</span>
      <input
        list="timezones"
        value={timeZone || ''}
        onChange={handleTimeZoneChange}
        name="time_zone"
        className={styles.text_general}
      />

      <datalist id="timezones">
        <option disabled={true} value="">
          Selecione um fuso horário
        </option>
        {glossaire_time_zone.map((timezone, index) => (
          <option key={index} value={timezone} selected={timeZone === timezone}>
            {timezone}
          </option>
        ))}
      </datalist>
    </>
  );
};

export default FormulaireSelectionTimeZone;
